import axios from "axios";

const { REACT_APP_FLASK_API_URL } = process.env;

export const getCampaignList = async(params) => {
   const response = await axios
     .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/digital-pr/campaigns/`, { params })
   
   return response;
 };

export const getLinksByMonth = async(params) => {
   const response = await axios
     .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/digital-pr/links/by-month/`, { params })

   return response;
 };

 export const getLinkAcquisitionsByMonth = async(params) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/digital-pr/links/by-link-month/`, { params })
  return response;
};

export const getDomainRatingDistribution = async(params) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/digital-pr/links/dr-distribution/`, { params })

  return response;
};

 export const getCampaignLinks = async(id) => {
   const response = await axios
     .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/digital-pr/campaigns/${id}/links/`)

   return response;
 };